import React from 'react';
import { css, cx } from 'linaria';
import ButtonWithLoading, { secondaryStyle } from '../../../ui/Button';
import { theme } from '../../../Theme';

export function VariantSelector({
  product,
  variantHandler,
  showValidation,
  disableOutOfStock
}) {
  return (
    <div className={sharedStyles}>
      {product?.variants?.options?.map((option, index) => {
        let showValidationMessage = false;
        if (
          showValidation &&
          variantHandler.getMissingOptions()?.includes(option)
        ) {
          showValidationMessage = true;
        }

        return (
          <ButtonSelect
            option={option}
            variantHandler={variantHandler}
            key={option.name}
            showValidationMessage={showValidationMessage}
            disableOutOfStock={disableOutOfStock}
            doNotDisable={index === 0}
          />
        );
      })}
    </div>
  );
}

const sharedStyles = css`
  margin-bottom: 40px;
  label {
    display: flex;
    padding-bottom: 0.25em;
    margin-top: 1em;
    align-items: center;
    font-weight: bold;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  .invalid {
    label {
      color: #eb5757;
    }
  }
  .missingVariant {
    margin-right: 0.25em;
    height: 10px;
    width: 10px;
  }
`;

const relative = css`
  position: relative;
  overflow: hidden;
  svg {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }
`;

function ButtonSelect({
  option,
  variantHandler,
  showValidationMessage,
  disableOutOfStock = true,
  doNotDisable
}) {
  const { getSelectedValue, validateSelection, selectValue } = variantHandler;
  const selectedValue = getSelectedValue(option);
  // const t = useIntl();

  return (
    <div
      className={cx(
        'button-select',
        buttonSelectStyles,
        showValidationMessage && 'invalid'
      )}
    >
      {/* <label>{t('Select {optionName}', { optionName: option.name })}</label> */}
      <label>{option.name}</label>
      {option?.values?.map((value, index) => {
        const validation = validateSelection(value, option);
        const disabled =
          index !== 0 &&
          (validation === 'invalid' ||
            (disableOutOfStock && validation === 'outOfStock'));

        return (
          <ButtonWithLoading
            data-testid={option.name + value}
            key={option.name + value}
            onClick={() => selectValue(value, option)}
            disabled={disabled}
            secondary={value !== selectedValue}
            aria-pressed={value === selectedValue}
            className={relative}
          >
            {value}
            {disabled && (
              <svg
                viewBox="0 0 1 1"
                preserveAspectRatio="none"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0 1L1 0"
                  stroke="currentColor"
                  strokeWidth="1"
                  vectorEffect="non-scaling-stroke"
                />
              </svg>
            )}
          </ButtonWithLoading>
        );
      })}
    </div>
  );
}

const buttonSelectStyles = css`
  margin: 1em 0;
  button {
    width: 80px;
    background: ${theme.colors.accent} !important;
    border: 0 !important;
    padding: 0 10px 0 10px !important;
    height: 35px;
    min-width: 50px;
    border-radius: ${theme.button.desktop.borderRadius} !important;
    &${secondaryStyle} {
      background: #e9e5df !important;
      :hover {
        background: ${theme.colors.accentlight} !important;
      }
    }
    + button {
      margin-left: 0.5em;
    }
  }
  &.invalid button {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
`;
